import { ArrowLeftCircleIcon, ArrowRightCircleIcon } from "@heroicons/react/24/solid";

interface SwitcherProps {
  idx: number;
  len: number;
  onRight: () => void;
  onLeft: () => void;
}

export function Switcher({ idx, len, onRight, onLeft }: SwitcherProps) {
  const arrowIconClasses = `size-7
    fill-tx-tertiary
    hover:fill-button-highlight-hover
    active:fill-action-tertiary
    transition duration-300 ease-out`;

  return (
    <div className="flex flex-row items-center space-x-6 p-2 md:space-x-2">
      {/* Left Arrow */}
      <button className="size-7" onClick={onLeft}>
        <ArrowLeftCircleIcon className={arrowIconClasses} />
      </button>
      {/* Message Index */}
      <p className="text-tx-tertiary font-mono text-sm font-semibold">{idx + 1 + "/" + (len + 1)}</p>
      {/* Right Arrow */}
      <button className="size-7" onClick={onRight}>
        <ArrowRightCircleIcon className={arrowIconClasses} />
      </button>
    </div>
  );
}
